export const openOrDownloadPdf = (link, blob, filename) => {
  if (validLink(link)) {
    const url = window.URL.createObjectURL(blob)
    return window.open(url)
  }
  downloadFile(link, blob, filename)
}

// trecho seguro para nome de arquivo: mantém letras (com acento) e dígitos
export const fileNamePart = (text, fallback = '') =>
  (text || '').replace(/[^\w\u00C0-\u017F]+/g, '_').replace(/^_+|_+$/g, '') || String(fallback)

// baixa a resposta arraybuffer de um endpoint de QR Code como arquivo .png
export const downloadPng = (data, filename) =>
  downloadFile(document.createElement('a'), new Blob([data], { type: 'image/png' }), filename)

export const downloadFile = (link, blob, filename) => {
  return (navigator.msSaveBlob && navigator.msSaveBlob(blob, filename)) || createLink(link, blob, filename)
}

const createLink = (link, blob, filename) => {
  if (validLink(link)) {
    const url = window.URL.createObjectURL(blob)

    link.setAttribute('href', url)
    link.setAttribute('download', filename)

    link.style = 'visibility: hidden'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

const validLink = (link) => {
  return link.download !== undefined
}



// WEBPACK FOOTER //
// ./src/utils/downloads.js